import { track } from "@amplitude/analytics-react-native";
import { amp } from "src/api/amplitude";
import PillButton from "src/components/PillButton";
import isWeb from "src/constants/isWeb";
import { useGatheringStore } from "src/contexts/GatheringContext";
import useKeyboardListener from "src/hooks/useKeyboardListener";

const DynamicSelectButton = () => {
	const resetSelectMode = useGatheringStore((state) => state.resetSelectMode);
	const setSelectMode = useGatheringStore((state) => state.setSelectMode);
	const selectMode = useGatheringStore((state) => state.selectMode);
	const handleSelectEnabled = () => {
		track(amp.gathering.selectButtonPressed);
		setSelectMode("Select");
	};
	const handleSelectDisabled = () => {
		track(amp.gathering.selectCancelButtonPressed);
		resetSelectMode();
	};
	useKeyboardListener(
		selectMode === "Select"
			? {
					Escape: () => {
						if (!isWeb) return;
						const searchParams = new URLSearchParams(window.location.search);
						if (!searchParams.has("photo")) {
							handleSelectDisabled();
						}
					},
				}
			: {},
	);

	if (selectMode === "Select") {
		return (
			<PillButton
				key="DynamicSelectButton"
				onPress={handleSelectDisabled}
				testID="GatheringNavBar-SelectCancel"
				opaque
			>
				Cancel
			</PillButton>
		);
	}
	if (selectMode === "None") {
		return (
			<PillButton
				key="DynamicSelectButton"
				onPress={handleSelectEnabled}
				testID="GatheringNavBar-Select"
				opaque
			>
				Select
			</PillButton>
		);
	}
	return null;
};
export default DynamicSelectButton;
